import { render } from "./ProjectPublicationHistoryListItemLink.vue?vue&type=template&id=a95e8f7c"
import script from "./ProjectPublicationHistoryListItemLink.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistoryListItemLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__